import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { KYMW9200Component } from './kymw9200.component';
import { GetCatalogInfoListService } from './api-services/get-catalog-info-list.service';
import { ImportCatalogCalendarService } from './api-services/import-catalog-calendar.service';

/**
 * 企画回管理画面 モジュール設定クラス
 *
 * @export KYMW9200Module
 * @class KYMW9200Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
  ],
  declarations: [
    KYMW9200Component,
  ],
  providers: [
    GetCatalogInfoListService,
    ImportCatalogCalendarService,
  ],
})
export class KYMW9200Module {

}
